import React, { Fragment } from 'react';
import { FusePageSimple } from '@fuse';
import { withStyles } from '@material-ui/core/styles';
import './QueryScreen.css';
import DataGroupInfoTable from './tables/DataGroupInfoTable';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import ReactSelect from 'react-select';
import { DatePicker } from 'material-ui-pickers';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import QueryChart from './QueryChart';
import { Tabs, Tab, TabList } from 'react-web-tabs';
import axiosInstance from '../common/AxiosInstace';
import history from "../../../history";
import EndpointsGetter from '../common/EndpointsGetter';
import moment from 'moment';
import FormLabel from '@material-ui/core/FormLabel';
import Checkbox from '@material-ui/core/Checkbox';
import debounce from 'lodash/debounce';
import { withRouter } from 'react-router-dom';
import TimeBucketsTable from './tables/TimeBucketsTable';
import AggregatesTable from './tables/AggregatesTable';
import DimensionsTable from './tables/DimensionsTable';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import reactSelectComponents from '../common/ReactSelectComponents';
import DrillDownDataContainer from './DrillDownDataContainer';
import CircularProgress from '@material-ui/core/CircularProgress';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import CircularBarplot from "../bar-chart/CircularBarplot";
import DoughnutTimeSelector from "../bar-chart/DoughnutTimeSelector";
import TabPanel from "react-web-tabs/es/TabPanel";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import Paper from "@material-ui/core/Paper/Paper";

const dimensionsMappingHelper = {
    "dim1": "d1",
    "dim2": "d2",
    "dim3": "d3",
    "dim4": "d4",
    "dim5": "d5"
};

const styles = theme => ({
    layoutRoot: {},
    container: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        width: '100%'
    },
    root: {
        flexGrow: 1,
        height: 250,
    },
    dateField: {
        marginTop: 20,
        marginBottom: 20,
        marginRight: 20
    },
    execButton: {
        marginTop: 20,
        width: '30%',
        whiteSpace: 'normal'
    },
    typeaheader: {
        marginBottom: 20
    },
    dimAttributes: {
        display: 'flex',
        'flex-direction': 'column',
        'margin-bottom': 15
    },
    nopaddingRow: {
        padding: '0 !important',
        margin: '0 !important',
    },
    inputLabels: {
        fontSize: 12,
        marginRight: 5
    },
    input: {
        display: 'flex',
        padding: 0,
    },
    valueContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flex: 1,
        alignItems: 'center',
        overflow: 'hidden',
    },
    chip: {
        margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
    },
    chipFocused: {
        backgroundColor: emphasize(
            theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
            0.08,
        ),
    },
    noOptionsMessage: {
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    },
    singleValue: {
        fontSize: 16,
    },
    placeholder: {
        position: 'absolute',
        left: 2,
        fontSize: 16,
    },
    paper: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    divider: {
        height: theme.spacing.unit * 2,
    },
    circularProgress: {
        'position': 'absolute', 'z-index': '1', 'margin-left': 'auto', 'margin-right': 'auto',
        'top': '22%', 'left': '35%', 'display': 'flex', 'flex-direction': 'column', 'align-items': 'center'
    },
    progressText: {
        marginTop: 18,
        fontSize: 18
    },
    button: {
        margin: theme.spacing.unit,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20
    }
});

const CIRCULAR_BARPLOT_MIN_AGGREGATION_INDEX = 3; // Week
const ATTRIBUTE_ACCUMULATE_UNIQUE = "Accumulate Unique";
const DOUGHNUT_MAX_LABELS_SHOWN = 23;
const TAB_KEY_LINE_CHART = "chart-tab";
const TAB_KEY_CIRCULAR_CHART = "circular-chart-tab";

class QueryScreen extends React.Component {
    constructor(props) {
        super(props);
        this.doughnutRef = React.createRef();

        this.state = {
            dataGroupName: '',
            dataGroupCode: '',
            url: '',
            query: '',
            queries: [],
            dimensions: [],
            dim1: { label: '', value: '' },
            dim2: { label: '', value: '' },
            dim3: { label: '', value: '' },
            dim4: { label: '', value: '' },
            dim5: { label: '', value: '' },
            dimsSuggestions: {
                dim1: [],
                dim2: [],
                dim3: [],
                dim4: [],
                dim5: [],
            },
            dimsLastSearch: {
                dim1: '',
                dim2: '',
                dim3: '',
                dim4: '',
                dim5: ''
            },
            dimsLoadingStatus: {
                dim1: false,
                dim2: false,
                dim3: false,
                dim4: false,
                dim5: false
            },
            startDate: null,
            endDate: null,
            selectedStartDate: null,
            selectedEndDate: null,
            selectedStartDateValid: true,
            selectedEndDateValid: true,
            fiscalYearStartDateValid: true,
            groupUrl: null,
            accessKey: null,
            executeDisabled: false,
            aggregationTypes: [],
            timeBuckets: [],
            groupData: null,
            output: null,
            selectedVerticalTabIndex: 1,
            selectedHorizontalTabIndex: 1,
            chartData: null,
            chartCursorFormat: null,
            datePeriods: null,
            setFiscalYear: false,
            fiscalYearStartDay: 1,
            fiscalYearStartMonth: 1,
            fiscalYearStartDate: new Date(new Date().getFullYear(), 0, 1),
            weekStandard: 1,
            weekStandards: [
                { label: 'ISO 8601 (Monday first day)', value: 1 },
                { label: 'US (Sunday first day)', value: 0 }
            ],
            lookupInputDelay: 650,
            isUserInputsValid: true,
            errorString: '',
            noAvailableData: false,
            noDataMessage: '',
            attributesIds: [],
            alwaysShowBullets: false,
            queryParams: [],
            drillDownResult: [],
            forbidAllActions: false,
            athenaQuery: {},
            isGridUpdating: false,
            queryParamsForPdfExport: [],
            chartAttributes: [],
            chartIterationRunning: false,
            circularBarplotVisualizationAvailable: false,
            circularBarplotData: null,
            circularBarplotMaxHeight: -1,
            circularVerticalIndexes: [],
            circularHorizontalIndexes: [],
            doughnutLabels: [],
            doughnutSelectedLabelsIndexes: [],
            doughnutIterationRunning: false,
            doughnutCenterText: '',
            tabListSelectedTab: TAB_KEY_LINE_CHART
        };
    }

    componentDidMount() {
        let accessToken = localStorage.getItem("access_token");
        if (accessToken == null || typeof accessToken == "undefined") {
            history.push('/login');
        } else {
            let pathParts = this.props.location.pathname.split('/');
            let id = pathParts[2];
            if (typeof id == 'undefined' || isNaN(id) || id == '') {
                history.push('/data-groups');
            } else {
                this.getDataGroup(id);
            }
        }
    }

    lookupDimensionsValues(queryData, field) {
        //DEV: axiosInstance.post('https://elb.kanin.io/groups/' + this.state.dataGroupCode + '/search', queryData, {
        //PROD: axiosInstance.post(this.state.groupUrl + '/groups/' + this.state.dataGroupCode + '/search', queryData, {
        axiosInstance.post(this.state.groupUrl + '/groups/' + this.state.dataGroupCode + '/search', queryData, {
            headers: {
                'Content-Type': 'application/json',
                'sectok': this.state.accessKey
            }
        })
            .then(response => {
                let suggestionsArray = [];
                if (response.data.Results != null) {
                    for (let i = 0; i < response.data.Results.length; i++) {
                        suggestionsArray.push({
                            label: response.data.Results[i],
                            value: response.data.Results[i]
                        })
                    }
                }
                let oldState = { ...this.state };
                oldState.dimsSuggestions[field] = suggestionsArray;
                oldState.dimsLoadingStatus[field] = false;
                this.setState(oldState);
            })
            .catch(error => {
                this.getError(error);
            });
    }

    setAllAggregationTypes() {
        let accessToken = localStorage.getItem("access_token");
        axiosInstance.get(EndpointsGetter.getAggTypesEndpoint(), {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                let oldState = { ...this.state };
                oldState.aggregationTypes = response.data.filter(function (obj) {
                    return obj.name !== 'Store Unique';
                });
                oldState.accessToken = accessToken;
                this.setState(oldState);
            })
            .catch(error => {
                this.getError(error);
            });
    }

    setAllTimeBuckets() {
        let accessToken = localStorage.getItem("access_token");
        axiosInstance.get(EndpointsGetter.getTimeBucketsEndpoint(), {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                let oldState = { ...this.state };
                oldState.timeBuckets = response.data;
                oldState.accessToken = accessToken;
                this.setState(oldState);
            })
            .catch(error => {
                this.getError(error);
            });
    }

    setAccountDetails() {
        let accessToken = localStorage.getItem("access_token");
        axiosInstance.get(EndpointsGetter.getAccountDetailsEndpoint(), {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                let oldState = { ...this.state };
                oldState.groupUrl = response.data.accountUrl;
                oldState.accessToken = accessToken;
                if (oldState.dataGroupCode != '') {
                    oldState.url = response.data.accountUrl + '/groups/' + oldState.dataGroupCode;
                }
                this.setState(oldState);
            })
            .catch(error => {
                this.getError(error);
            });
    }

    getDataGroup(groupId) {
        let accessToken = localStorage.getItem("access_token");
        axiosInstance.get(EndpointsGetter.getDataGroupEndpoint() + '/' + groupId, {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                if (response.data.status === 'active' && (response.data.records !== null && parseInt(response.data.records) > 0)) {
                    this.setAllAggregationTypes();
                    this.setAllTimeBuckets();
                    this.setAccountDetails();

                    let oldState = { ...this.state };
                    oldState.accessToken = accessToken;
                    oldState.accessKey = response.data.securityKey;
                    oldState.groupData = response.data;
                    oldState.queries = this.getQueries(this.getDimensionsData(response.data.aggregationDimensions));
                    this.setState(oldState);
                    this.setGroupData(response.data);
                } else {
                    history.push('/data-groups');
                }
            })
            .catch(error => {
                this.getError(error);
            });
    }

    setWeekNumber(weekStandard, queryData) {
        let oldState = { ...this.state };
        oldState.executeDisabled = true;
        this.setState(oldState);

        let qs = require('qs');
        let accessToken = localStorage.getItem("access_token");
        axiosInstance.post(EndpointsGetter.getWeekNumberEndpoint(), qs.parse(weekStandard), {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                this.setState({
                    accessToken: accessToken,
                    queryPeriodWeeks: response.data.weeks
                });
                this.queryDataGroup(queryData);
            })
            .catch(error => {
                let oldState = { ...this.state };
                oldState.executeDisabled = false;
                this.setState(oldState);
                this.getError(error);
            });
    }

    queryDataGroup(obj) {
        let qs = require('qs');
        //DEV: axiosInstance.post('https://elb.kanin.io/groups/' + obj.groupCode, qs.parse(obj.queryData), {
        //PROD: axiosInstance.post(this.state.groupUrl + '/groups/' + obj.groupCode, qs.parse(obj.queryData), {
        axiosInstance.post(this.state.groupUrl + '/groups/' + obj.groupCode, qs.parse(obj.queryData), {
            headers: {
                'Content-Type': 'application/json',
                'sectok': this.state.accessKey
            }
        })
            .then(response => {
                if (response.data.Results.length < 1) {
                    this.setState({
                        output: null,
                        errorString: 'No available data',
                        isUserInputsValid: false,
                        executeDisabled: false
                    });
                } else {
                    this.setState({
                        output: response.data.Results.filter(function (obj) {
                            return obj.OperationTypeId !== 3;
                        }),
                        circularBarplotVisualizationAvailable: this.getAccumulateUniqueAttributeIds(response.data.Results).length > 0
                    });
                    let selectedAttributeObject = this.state.output[0];
                    let index = 0;
                    for (let i = 1; i <= 8; i++) {
                        if (typeof selectedAttributeObject.TimeContainers[i] != 'undefined' && Object.keys(selectedAttributeObject.TimeContainers[i]).length !== 0) {
                            index = i;
                            break;
                        }
                    }
                    if (index > 0) {
                        this.setState({
                            selectedHorizontalTabIndex: index,
                            selectedVerticalTabIndex: 1,
                            executeDisabled: false
                        });
                        this.setChartData(index, 1, false);
                    } else {
                        if (this.state.groupData.aggregationTimeBuckets.length > 0) {
                            index = this.state.groupData.aggregationTimeBuckets[0].id;
                            this.setState({
                                selectedHorizontalTabIndex: index,
                                selectedVerticalTabIndex: 1,
                                executeDisabled: false
                            });
                            this.setChartData(index, 1, false);
                        } else {
                            this.setState({
                                output: null,
                                errorString: 'No available data',
                                isUserInputsValid: false,
                                executeDisabled: false,
                                selectedVerticalTabIndex: 1,
                            });
                        }
                    }
                }
            })
            .catch(error => {
                let oldState = { ...this.state };
                oldState.executeDisabled = false;
                this.setState(oldState);
                this.getError(error);
            });
    }

    getError(error) {
        let errorString = '';
        if (error.code === 'ECONNABORTED') {
            errorString = "API Request timed out. Please try again after few seconds";
        } else if (error.response.status === 500) {
            errorString = "Operation was unsuccessful. Please try again after few seconds";
        } else if (error.response.status === 404) {
            errorString = "Error 404";
        } else if (error.response.status === 401) {
            // errorString = "Unauthorized";
        } else {
            errorString = error.response.data.message ? error.response.data.message : error.response.data.error_description;
            if (error.response.status === 400 && errorString.includes("Invalid refresh token")) {
                history.push('/login');
            }
        }
        this.setState({
            isGridUpdating: false,
            isUserInputsValid: false,
            errorString: errorString,
            forbidAllActions: false
        });
    }

    setGroupData(data) {
        if (data != null) {
            let formattedStartDate = data.startDate ? moment(data.startDate).valueOf() : null,
                formattedEndDate = data.endDate ? moment(data.endDate).valueOf() : null;

            this.setState({
                dataGroupName: data.name,
                dataGroupCode: data.code,
                url: this.getUrl(data.code),
                dimensions: this.getDimensionsData(data.aggregationDimensions),
                startDate: formattedStartDate,
                endDate: formattedEndDate,
                selectedStartDate: formattedStartDate,
                selectedEndDate: formattedEndDate
            });
            this.forceUpdate();
        }
    }

    getDimensionsData(groupAggDimensions) {
        let dimensionsData = [];
        for (let obj of groupAggDimensions) {
            dimensionsData.push({
                d1: typeof obj.dimensions[0] !== 'undefined' ? obj.dimensions[0] : '',
                d2: typeof obj.dimensions[1] !== 'undefined' ? obj.dimensions[1] : '',
                d3: typeof obj.dimensions[2] !== 'undefined' ? obj.dimensions[2] : '',
                d4: typeof obj.dimensions[3] !== 'undefined' ? obj.dimensions[3] : '',
                d5: typeof obj.dimensions[4] !== 'undefined' ? obj.dimensions[4] : ''
            })
        }
        return dimensionsData;
    }

    getUrl(code) {
        return this.state.groupUrl + '/groups/' + code;
    }

    getDimensions(selectedQuery) {
        let dimensionsToReturn = [];
        this.state.queries.forEach(function (queryElement) {
            if (queryElement.value == selectedQuery) {
                dimensionsToReturn.push(
                    {
                        d1: queryElement.d1,
                        d2: queryElement.d2,
                        d3: queryElement.d3,
                        d4: queryElement.d4,
                        d5: queryElement.d5
                    }
                )
            }
        });
        return dimensionsToReturn;
    }

    getQueries(dimensions) {
        let queriesToReturn = [];
        for (let i = 0; i < dimensions.length; i++) {
            let queryToPush = {
                value: ((dimensions[i].d1 != '' ? dimensions[i].d1 : '') +
                    (dimensions[i].d2 != '' ? ' + ' + dimensions[i].d2 : '') +
                    (dimensions[i].d3 != '' ? ' + ' + dimensions[i].d3 : '') +
                    (dimensions[i].d4 != '' ? ' + ' + dimensions[i].d4 : '') +
                    (dimensions[i].d5 != '' ? ' + ' + dimensions[i].d5 : '')),
                d1: dimensions[i].d1,
                d2: dimensions[i].d2,
                d3: dimensions[i].d3,
                d4: dimensions[i].d4,
                d5: dimensions[i].d5
            };
            queriesToReturn.push(queryToPush);
        }
        return queriesToReturn;
    }

    handleFocus(e, attribute, field) {
        let executeLookup = false;
        let queryData = [];
        let attributeValues = [
            {
                attr: this.state.dimensions[0].d1,
                val: this.state.dim1.value
            }, {
                attr: this.state.dimensions[0].d2,
                val: this.state.dim2.value
            }, {
                attr: this.state.dimensions[0].d3,
                val: this.state.dim3.value
            }, {
                attr: this.state.dimensions[0].d4,
                val: this.state.dim4.value
            }, {
                attr: this.state.dimensions[0].d5,
                val: this.state.dim5.value
            }
        ];
        attributeValues.forEach(function (element) {
            if (element.attr !== '') {
                if (element.attr === attribute) {
                    element["lookup"] = true;
                    /*if (element.val == '') {*/
                    executeLookup = true;
                    /*}*/
                }
                queryData.push(element);
            }
        });

        if (executeLookup) {
            let oldState = { ...this.state };
            oldState.dimsLoadingStatus[field] = true;
            oldState.dimsSuggestions[field] = [];
            this.setState(oldState);
            this.lookupDimensionsValues(queryData, field);
        }

    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value
        });
    };

    onDimChange = name => value => {
        this.handleDimChange(name, value);
    };

    handleDimChange(name, value) {
        const dimensionKey = this.state.dimensions[0][dimensionsMappingHelper[name]];
        if (!value || value.length === 0) {
            value = { label: '', value: '' };
            let attribute = name == 'dim1' ?
                this.state.dimensions[0].d1 : name == 'dim2' ?
                    this.state.dimensions[0].d2 : name == 'dim3' ?
                        this.state.dimensions[0].d3 : name == 'dim4' ?
                            this.state.dimensions[0].d4 : this.state.dimensions[0].d5;
            // Simulate input change event when the field value is deleted
            this.handleSelectorChanges(attribute, name, value.value, "empty-field");
            this.setState(prevState => ({
                queryParams: prevState.queryParams.filter(param => param.key !== dimensionKey)
            }));
        } else {
            // Set the selected value in the search history
            this.setState(prevState => {
                const queryExists = prevState.queryParams.findIndex(param => param.key === dimensionKey),
                    identicalQuery = prevState.queryParams.findIndex(param => param.key === dimensionKey && param.value === value.value);
                return {
                    dimsLastSearch: { ...prevState.dimsLastSearch, [name]: value.value },
                    queryParams: queryExists === -1 ? [...prevState.queryParams, {
                        "key": dimensionKey,
                        "value": value.value
                    }] : identicalQuery !== -1 ? prevState.queryParams : prevState.queryParams.map((queryParam, idx) => (
                        queryExists === idx ? {
                            "key": dimensionKey,
                            "value": value.value
                        } : queryParam
                    ))
                }
            });
        }

        this.setState({
            [name]: value
        });
    }

    handleInputChange = (attribute, field) => (val, action) => {
        this.handleSelectorChanges(attribute, field, val, action);
    };

    handleSelectorChanges(attribute, field, val, action) {
        if (this.state.dimsLastSearch[field] != val) {
            if (action.action !== "input-blur" && action.action !== "menu-close") {
                this.state.dimsLastSearch[field] = val;
                if (action.action === "set-value") {
                    return;
                }
            } else {
                return;
            }

            let queryData = [];
            let attributeValues = [
                {
                    attr: this.state.dimensions[0].d1,
                    val: this.state.dim1.value
                }, {
                    attr: this.state.dimensions[0].d2,
                    val: this.state.dim2.value
                }, {
                    attr: this.state.dimensions[0].d3,
                    val: this.state.dim3.value
                }, {
                    attr: this.state.dimensions[0].d4,
                    val: this.state.dim4.value
                }, {
                    attr: this.state.dimensions[0].d5,
                    val: this.state.dim5.value
                }
            ];
            attributeValues.forEach(function (element) {
                if (element.attr !== '') {
                    if (element.attr === attribute) {
                        element["lookup"] = true;
                        element.val = val;
                    }
                    queryData.push(element);
                }
            });
            let oldState = { ...this.state };
            oldState.dimsLoadingStatus[field] = true;
            oldState.dimsSuggestions[field] = [];
            this.setState(oldState);
            this.lookupDimensionsValues(queryData, field);
        }
    }

    handleFiscalYearDateChange = name => value => {
        this.setState({
            [name]: new Date(value),
            fiscalYearStartDay: new Date(value).getDate(),
            fiscalYearStartMonth: (new Date(value).getMonth() + 1),
        });
    };

    validateDates(param, minDate, maxDate, value) {
        let date = moment(value);
        let outOfRange = false;
        if (date.isValid() && minDate !== null && maxDate !== null) {
            if (date.isBefore(moment(minDate), 'day') || date > moment(maxDate)) {
                outOfRange = true;
            }
        }
        this.setState({
            [param]: outOfRange ? false : date.isValid()
        });
    };

    handleDateChange = name => value => {
        let { startDate, selectedEndDate, selectedStartDate, endDate, executeDisabled, selectedStartDateValid, selectedEndDateValid } = this.state;
        if (!executeDisabled) {
            //handling all cases where validation needs to happen, should be refactored at some point.
            if (!selectedStartDateValid && !selectedEndDateValid) {
                if (name === 'selectedStartDate') {
                    this.validateDates('selectedStartDateValid', startDate, moment(selectedEndDate), value);
                    this.validateDates('selectedEndDateValid', moment(value), endDate, selectedEndDate);
                } else {
                    this.validateDates('selectedStartDateValid', startDate, moment(value), selectedStartDate);
                    this.validateDates('selectedEndDateValid', moment(value), endDate, value);
                }
            } else if (!selectedStartDateValid) {
                if (name === 'selectedStartDate') this.validateDates('selectedStartDateValid', startDate, moment(selectedEndDate), value);
                else this.validateDates('selectedStartDateValid', startDate, moment(value), selectedStartDate);

            } else if (!selectedEndDateValid) {
                if (name === 'selectedStartDate') this.validateDates('selectedEndDateValid', moment(value), endDate, selectedEndDate);
                else this.validateDates('selectedEndDateValid', startDate, endDate, value);
            }
        }

        //These conditions need to happen, because there is a problem with the DatePicker and this is a way to fix that particular problem. 
        //It'll be best if the package for date picker is changed.
        const momentValue = name === 'selectedStartDate' ? moment(value).add(1, 'milliseconds').valueOf() :
            moment(value).valueOf() === endDate ? moment(value).subtract(1, 'milliseconds').valueOf() : moment(value).add(1, 'milliseconds').valueOf();
        this.setState({ [name]: moment(value).valueOf() < startDate ? startDate : momentValue });
    };

    handleQueryChange = name => event => {
        this.setState(prevState => {
            const clearQueryParams = ((prevState.query && event.target.value) && (prevState.query !== event.target.value));
            return {
                [name]: event.target.value,
                queryParams: clearQueryParams ? [] : prevState.queryParams,
                dimensions: this.getDimensions(event.target.value),
                dim1: { label: '', value: '' },
                dim2: { label: '', value: '' },
                dim3: { label: '', value: '' },
                dim4: { label: '', value: '' },
                dim5: { label: '', value: '' },
                dimsSuggestions: {
                    dim1: [],
                    dim2: [],
                    dim3: [],
                    dim4: [],
                    dim5: []
                }
            }
        })
    };

    sanitizeUserInput(string) {
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#x27;',
            "/": '&#x2F;',
        };
        const reg = /[&<>"'/]/ig;
        return string.replace(reg, (match) => (map[match]));
    }

    validateUserInput(state) {
        if (state.query != null && typeof state.query != 'undefined' && state.query == '') {
            this.state.errorString = 'Query field cannot be empty!';
            this.state.isUserInputsValid = false;
            return false;
        }
        if (state.dimensions[0] != null && typeof state.dimensions[0] != 'undefined' && state.dimensions[0].d1 != '') {
            if (state.dim1 != null && typeof state.dim1 != 'undefined' && state.dim1.value == '') {
                this.state.errorString = 'Query search values fields cannot be empty!';
                this.state.isUserInputsValid = false;
                return false;
            }
        }
        if (state.dimensions[0] != null && typeof state.dimensions[0] != 'undefined' && state.dimensions[0].d2 != '') {
            if (state.dim2 != null && typeof state.dim2 != 'undefined' && state.dim2 == '') {
                this.state.errorString = 'Query search values fields cannot be empty!';
                this.state.isUserInputsValid = false;
                return false;
            }
        }
        if (state.dimensions[0] != null && typeof state.dimensions[0] != 'undefined' && state.dimensions[0].d3 != '') {
            if (state.dim3 != null && typeof state.dim3 != 'undefined' && state.dim3 == '') {
                this.state.errorString = 'Query search values fields cannot be empty!';
                this.state.isUserInputsValid = false;
                return false;
            }
        }
        if (state.dimensions[0] != null && typeof state.dimensions[0] != 'undefined' && state.dimensions[0].d4 != '') {
            if (state.dim4 != null && typeof state.dim4 != 'undefined' && state.dim4 == '') {
                this.state.errorString = 'Query search values fields cannot be empty!';
                this.state.isUserInputsValid = false;
                return false;
            }
        }
        if (state.dimensions[0] != null && typeof state.dimensions[0] != 'undefined' && state.dimensions[0].d5 != '') {
            if (state.dim5 != null && typeof state.dim5 != 'undefined' && state.dim5 == '') {
                this.state.errorString = 'Query search values fields cannot be empty!';
                this.state.isUserInputsValid = false;
                return false;
            }
        }
        if (state.selectedStartDate != null && typeof state.selectedStartDate != 'undefined') {
            if (state.selectedStartDate < state.startDate) {
                this.state.errorString = "Start date cannot be earlier than group's start date!";
                this.state.isUserInputsValid = false;
                return false;
            }
            if (state.selectedStartDate > state.selectedEndDate) {
                this.state.errorString = "Start date cannot be later than end date!";
                this.state.isUserInputsValid = false;
                return false;
            }
            if (state.selectedStartDate > state.endDate) {
                this.state.errorString = "Start date cannot be later than group's end date!";
                this.state.isUserInputsValid = false;
                return false;
            }
        }
        if (state.selectedEndDate != null && typeof state.selectedEndDate != 'undefined') {
            if (state.selectedEndDate > state.endDate) {
                this.state.errorString = "End date cannot be later than group's end date!";
                this.state.isUserInputsValid = false;
                return false;
            }
            if (state.selectedEndDate < state.selectedStartDate) {
                this.state.errorString = "End date cannot be earlier than start date!";
                this.state.isUserInputsValid = false;
                return false;
            }
            if (state.selectedEndDate < state.startDate) {
                this.state.errorString = "End date cannot be earlier than group's start date!";
                this.state.isUserInputsValid = false;
                return false;
            }
        }
        this.state.isUserInputsValid = true;
        return true;
    }

    handleExecuteQueryDataGroup() {
        if (this.validateUserInput(this.state)) {
            /*state.dim1 = this.sanitizeUserInput(state.dim1);
            state.dim2 = this.sanitizeUserInput(state.dim2);
            state.dim3 = this.sanitizeUserInput(state.dim3);*/

            let query = [];
            if (this.state.dimensions[0].d1 != '')
                query.push(this.state.dimensions[0].d1);
            if (this.state.dimensions[0].d2 != '')
                query.push(this.state.dimensions[0].d2);
            if (this.state.dimensions[0].d3 != '')
                query.push(this.state.dimensions[0].d3);
            if (this.state.dimensions[0].d4 != '')
                query.push(this.state.dimensions[0].d4);
            if (this.state.dimensions[0].d5 != '')
                query.push(this.state.dimensions[0].d5);

            let querySearchValues = [];
            if (query[0] != null) {
                querySearchValues.push(this.state.dim1.value);
            }
            if (query[1] != null) {
                querySearchValues.push(this.state.dim2.value);
            }
            if (query[2] != null) {
                querySearchValues.push(this.state.dim3.value);
            }
            if (query[3] != null) {
                querySearchValues.push(this.state.dim4.value);
            }
            if (query[4] != null) {
                querySearchValues.push(this.state.dim5.value);
            }

            let sDate = new Date(this.state.selectedStartDate);
            let startDate = sDate.getFullYear() + "-" +
                ("0" + (sDate.getMonth() + 1)).slice(-2) + "-" +
                ("0" + sDate.getDate()).slice(-2) + " " + "00:00:00";
            let eDate = new Date(this.state.selectedEndDate);
            let endDate = eDate.getFullYear() + "-" +
                ("0" + (eDate.getMonth() + 1)).slice(-2) + "-" +
                ("0" + eDate.getDate()).slice(-2) + " " + "23:59:59";
            let yearStart = this.state.fiscalYearStartDate.getFullYear() + "-" +
                ("0" + (this.state.fiscalYearStartDate.getMonth() + 1)).slice(-2) + "-" +
                ("0" + this.state.fiscalYearStartDate.getDate()).slice(-2);

            let queryData = {
                queryData: {
                    Query: query,
                    QuerySearchValues: querySearchValues,
                    StartDate: startDate,
                    YearStart: yearStart,
                    EndDate: endDate,
                    WeekStartDay: this.state.weekStandard
                },
                groupCode: this.state.dataGroupCode
            };
            this.setState({
                reportStartDate: startDate,
                reportEndDate: endDate,
                output: null,
                chartData: null,
                chartCursorFormat: null,
                minPeriod: null,
                alwaysShowBullets: false,
                chosenCategory: null,
                selectedVerticalTabIndex: 1,
                selectedHorizontalTabIndex: 1,
                errorString: '',
                isUserInputsValid: false
            });
            this.state.reportStartDate = startDate;
            let weekStandard = {
                standard: this.state.weekStandard === 1 ? "ISO 8601" : "US",
                startDate: startDate.split(" ")[0],
                endDate: endDate.split(" ")[0]
            };
            this.setWeekNumber(weekStandard, queryData);
        } else {
            this.forceUpdate();
        }
    }

    createVerticalTabs() {
        if (this.state.aggregationTypes.length > 0) {
            let tabs = [];
            for (let i = 0; i < this.state.output.length; i++) {
                let aggregationType = this.state.aggregationTypes.find(obj => {
                    return obj.id === this.state.output[i].OperationTypeId
                }).name;

                tabs.push(
                    <Tab key={i} tabFor={(i + 1).toString()}>
                        {this.state.output[i].Attribute}
                        <br />
                        ({aggregationType})
                    </Tab>
                );
                if (this.state.attributesIds.length < 2) {
                    if (typeof aggregationType !== 'undefined' && aggregationType !== null && (aggregationType == "Min" || aggregationType == "Max")) {
                        this.state.attributesIds.push(i + 1)
                    }
                }
            }
            return tabs.length < 1 ? null : tabs;
        }
    }

    createHorizontalTabs() {
        if (this.state.timeBuckets.length > 0) {
            let sortedGroupTimeBuckets = this.sortAggregationTimeBuckets();
            let tabs = [];

            sortedGroupTimeBuckets.forEach(function (groupTB, idx) {
                if (groupTB.id !== 9) { //hide real time data for now from the query screen
                    tabs.push(
                        <Tab key={idx} tabFor={groupTB.id.toString()}>
                            {'by ' + this.state.timeBuckets[groupTB.id - 1].name}
                        </Tab>
                    )
                }
            }, this);

            return tabs.length < 1 ? null : tabs;
        }
    }

    sortAggregationTimeBuckets= () => {
        return this.state.groupData.aggregationTimeBuckets.sort((a, b) => a.id - b.id);
    }

    checkIfPeriodWithinRange(checkStartDate, checkEndDate, minDate, maxDate) {
        return checkStartDate >= minDate && checkStartDate <= maxDate && checkEndDate >= minDate && checkEndDate <= maxDate;
    }

    getFiscalStartYear(periodStart) {
        let startYear = moment(periodStart, 'YYYY/MM/DD').format('YYYY');
        if (this.state.fiscalYearStartMonth == moment(periodStart, 'YYYY/MM/DD').format('M')) {
            if (this.state.fiscalYearStartDay > moment(periodStart, 'YYYY/MM/DD').format('D')) {
                startYear = moment(periodStart, 'YYYY/MM/DD').format('YYYY') - 1;
            }
        } else {
            let dif = 12 - this.state.fiscalYearStartMonth;
            if (12 - moment(periodStart, 'YYYY/MM/DD').format('M') >= dif) {
                startYear = moment(periodStart, 'YYYY/MM/DD').format('YYYY') - 1;
            } else {
                startYear = moment(periodStart, 'YYYY/MM/DD').format('YYYY');
            }
        }
        return startYear;
    }

    getCurrentQuarter(periodStart, periodEnd) {
        let currentQuarter = null;
        let startYear = null;
        if (this.state.fiscalYearStartMonth !== 1 || this.state.fiscalYearStartDay !== 1) {
            startYear = this.getFiscalStartYear(periodStart);
        } else {
            startYear = moment(periodStart, 'YYYY/MM/DD').format('YYYY');
        }
        let yearStartDate = moment(startYear.toString().concat('/').concat(this.state.fiscalYearStartMonth.toString()).concat('/').concat(this.state.fiscalYearStartDay.toString()));
        if (this.checkIfPeriodWithinRange(moment(periodStart, 'YYYY/MM/DD'), moment(periodEnd, 'YYYY/MM/DD'), yearStartDate, moment(yearStartDate).add(3, 'months'))) {
            currentQuarter = 1;
        } else {
            for (let j = 1; j < 4; j++) {
                if (this.checkIfPeriodWithinRange(moment(periodStart, 'YYYY/MM/DD'), moment(periodEnd, 'YYYY/MM/DD'), moment(yearStartDate).add(j * 3, 'months'), moment(yearStartDate).add(j * 3 + 3, 'months'))) {
                    currentQuarter = j + 1;
                }
            }
        }

        // Just for the case when the fiscal year starts at 28/02
        if (this.state.fiscalYearStartDay === 28 && this.state.fiscalYearStartMonth === 2 && currentQuarter == null) {
            let endOfPeriod = moment(periodEnd, 'YYYY/MM/DD');
            if (endOfPeriod.format('D') === '27' && endOfPeriod.format('M') === '2') {
                currentQuarter = 4;
            } else if (endOfPeriod.format('D') === '30' && endOfPeriod.format('M') === '5') {
                currentQuarter = 1;
            } else if (endOfPeriod.format('D') === '30' && endOfPeriod.format('M') === '8') {
                currentQuarter = 2;
            } else if (endOfPeriod.format('D') === '29' && endOfPeriod.format('M') === '11') {
                currentQuarter = 3;
            }
        }

        return currentQuarter;
    }

    getCurrentHalf(periodStart, periodEnd) {
        let currentHalf = null;
        let startYear = null;
        if (this.state.fiscalYearStartMonth !== 1 || this.state.fiscalYearStartDay !== 1) {
            startYear = this.getFiscalStartYear(periodStart);
        } else {
            startYear = new Date(periodStart).getFullYear();
        }
        let yearStartDate = moment(startYear.toString().concat('/').concat(this.state.fiscalYearStartMonth.toString()).concat('/').concat(this.state.fiscalYearStartDay.toString()));
        if (this.checkIfPeriodWithinRange(moment(periodStart, 'YYYY/MM/DD'), moment(periodEnd, 'YYYY/MM/DD'), yearStartDate, moment(yearStartDate).add(6, 'months'))) {
            currentHalf = 1;
        } else {
            currentHalf = 2;
        }
        return currentHalf;
    }

    setChartData(horizontalTabIndex, verticalTabIndex, isCircularBarplotChart) {
        let data = [],
            cursorFormat = '',
            selectedAttributeObject = this.state.output[verticalTabIndex - 1],
            timeBucketData = selectedAttributeObject.TimeContainers[horizontalTabIndex],
            lastTS = selectedAttributeObject.LastTS,
            minPeriod = 'mm',
            dataPeriods = {},
            currentPeriod = null,
            category = null,
            currentQuarter = null,
            currentHalf = null,
            calendarYear = null,
            fiscalYear = null,
            attributes = [];

        if (horizontalTabIndex > 3 && horizontalTabIndex != 5 &&
            selectedAttributeObject.TimeContainerPeriods && selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex] !== null &&
            typeof selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex] !== 'undefined') {
            calendarYear = moment(selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex][0].Start, 'YYYY/MM/DD').format('YYYY');
            fiscalYear = this.getFiscalStartYear(selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex][0].Start);
            fiscalYear++;
        }

        // define the way bullets appears on chart
        // if ( horizonalTab == by Minute && ( verticalTab == Min || verticalTab == Max ) )

        if (horizontalTabIndex == 1 && this.state.attributesIds.indexOf(verticalTabIndex) != -1) {
            this.state.alwaysShowBullets = true
        } else {
            this.state.alwaysShowBullets = false
        }

        //this.state.alwaysShowBullets = horizontalTabIndex === 1 && this.state.attributesIds.indexOf(verticalTabIndex) !== -1;

        if (typeof timeBucketData != 'undefined' && Object.keys(timeBucketData).length !== 0) {
            for (let i = 0; i < timeBucketData.length; i++) {
                let date = moment(this.state.reportStartDate, 'YYYY/MM/DD hh:mm');
                if (horizontalTabIndex == 1) {
                    //Minute
                    cursorFormat = 'YYYY/MM/DD HH:mm';
                    date = moment(date).add(i, 'm');
                    date = moment(date, cursorFormat).format(cursorFormat);
                    minPeriod = 'mm';
                    category = 'minute';
                    currentPeriod = moment(date, 'YYYY/MM/DD HH:mm').format('HH:mm');
                } else if (horizontalTabIndex == 2) {
                    //Hour
                    cursorFormat = 'YYYY/MM/DD HH:mm';
                    date = moment(date).add(i, 'h');
                    date = moment(date, cursorFormat).format(cursorFormat);
                    minPeriod = 'hh';
                    category = 'hour';
                    currentPeriod = moment(date, 'YYYY/MM/DD HH:mm').format('HH:mm');
                } else if (horizontalTabIndex == 3) {
                    //Day
                    cursorFormat = 'YYYY-MM-DD';
                    date = moment(date).add(i, 'd');
                    date = moment(date, cursorFormat).format(cursorFormat);
                    minPeriod = 'DD';
                    category = 'day';
                    currentPeriod = moment(date, 'YYYY/MM/DD').format('MMM DD');
                } else if (horizontalTabIndex == 4) {
                    //Week
                    cursorFormat = 'YYYY-MM-DD';
                    date = selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex][i].Start;
                    minPeriod = 'DD';
                    category = 'week';
                    dataPeriods = selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex][i];
                    if (new Date(selectedAttributeObject.TimeContainerPeriods[4][i].End).getFullYear() > calendarYear) {
                        calendarYear++;
                    }
                    let month = moment(selectedAttributeObject.TimeContainerPeriods[4][i].End, 'YYYY/MM/DD').format('M');
                    currentPeriod = (month == 1 && this.state.queryPeriodWeeks[i].weekNumber >= 50 ?
                        (calendarYear - 1).toString() : calendarYear) + '-' + this.state.queryPeriodWeeks[i].weekNumber.toString();
                } else if (horizontalTabIndex == 5) {
                    //Month
                    cursorFormat = 'YYYY-MM';
                    date = moment(selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex][i].Start, cursorFormat).format(cursorFormat);
                    minPeriod = 'MM';
                    category = 'month';
                    currentPeriod = moment(date, 'YYYY/MM/DD').format('M') == '1' ? moment(date, 'YYYY/MM/DD').format('YYYY') : moment(date, 'YYYY/MM/DD').format('MMM');
                } else if (horizontalTabIndex == 6) {
                    //Quarter
                    category = 'quarter';
                    if (this.state.fiscalYearStartDay !== 1 || this.state.fiscalYearStartMonth !== 1) {
                        if (currentQuarter === null) {
                            currentQuarter = this.getCurrentQuarter(selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex][i].Start,
                                selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex][i].End);
                        } else {
                            if (currentQuarter + 1 === 5) {
                                currentQuarter = 1;
                                fiscalYear++;
                            } else {
                                currentQuarter += 1;
                            }
                        }
                        currentPeriod = fiscalYear.toString().concat('-Q').concat(currentQuarter.toString());
                        cursorFormat = 'YYYY-MM-DD';
                    } else {
                        if (currentQuarter === null) {
                            currentQuarter = this.getCurrentQuarter(selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex][i].Start,
                                selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex][i].End);
                        } else {
                            if (currentQuarter + 1 === 5) {
                                currentQuarter = 1;
                                calendarYear++;
                            } else {
                                currentQuarter += 1;
                            }
                        }
                        currentPeriod = calendarYear.toString().concat('-Q').concat(currentQuarter.toString());
                        cursorFormat = 'YYYY-MM';
                    }
                    date = selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex][i].Start;
                    dataPeriods = selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex][i];
                    minPeriod = 'MM';
                } else if (horizontalTabIndex == 7) {
                    //Half Year
                    category = 'half';
                    if (currentHalf === null) {
                        currentHalf = this.getCurrentHalf(selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex][i].Start,
                            selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex][i].End);
                    } else {
                        currentHalf = currentHalf === 2 ? 1 : 2;
                    }
                    if (this.state.fiscalYearStartDay !== 1 || this.state.fiscalYearStartMonth !== 1) {
                        let periodYear = currentHalf === 2 ? (fiscalYear++).toString() : fiscalYear.toString();
                        let periodHalf = currentHalf === 2 ? '-H2' : '-H1';
                        currentPeriod = periodYear.concat(periodHalf);
                        cursorFormat = 'YYYY-MM-DD';
                    } else {
                        let periodYear = currentHalf === 2 ? (calendarYear++).toString() : calendarYear.toString();
                        let periodHalf = currentHalf === 2 ? '-H2' : '-H1';
                        currentPeriod = periodYear.concat(periodHalf);
                        cursorFormat = 'YYYY-MM';
                    }
                    date = new Date(selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex][i].Start);
                    dataPeriods = selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex][i];
                    minPeriod = 'MM';
                } else if (horizontalTabIndex == 8) {
                    //Year
                    category = 'year';
                    date = moment(selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex][i].End, 'YYYY').format('YYYY');
                    if (this.state.fiscalYearStartDay !== 1 || this.state.fiscalYearStartMonth !== 1) {
                        dataPeriods = selectedAttributeObject.TimeContainerPeriods[horizontalTabIndex][i];
                        currentPeriod = fiscalYear.toString();
                        fiscalYear++;
                        cursorFormat = 'YYYY-MM-DD';
                    } else {
                        cursorFormat = 'YYYY';
                        currentPeriod = moment(date, 'YYYY/MM/DD').format('YYYY');
                    }
                    minPeriod = 'YYYY';
                }
                if (selectedAttributeObject.OperationTypeId === 8) {
                    // Accumulate unique
                    // example: timeBucketData[i] = {uniqueValOne: 104, uniqueValTwo: 10}
                    let dataObj = {
                        date: date,
                        dataPeriods: dataPeriods,
                        currentPeriod: currentPeriod,
                        category: category
                    };
                    if (timeBucketData[i]) {
                        Object.keys(timeBucketData[i]).forEach((attr) => {
                            // 4 default properties + max 10 lines that can be drawn on chart = 14
                            //TODO remove hardcoding
                            let maxObjectKeys = isCircularBarplotChart ? 100 : 14;
                            if (Object.keys(dataObj).length < maxObjectKeys) {
                                dataObj[attr] = timeBucketData[i][attr];
                                if (!attributes.includes(attr)) {
                                    attributes.push(attr);
                                }
                            }
                        });
                    }
                    data.push(dataObj);
                } else {
                    data.push({
                        date: date,
                        value: timeBucketData[i],
                        dataPeriods: dataPeriods,
                        currentPeriod: currentPeriod,
                        category: category
                    })
                }
            }
            this.setState({
                chartData: data,
                chartAttributes: attributes,
                chartCursorFormat: cursorFormat,
                noAvailableData: false,
                minPeriod: minPeriod,
                chosenCategory: category,
                queryParamsForPdfExport: cloneDeep(this.state.queryParams)
            }, () => this.setDoughnutLabels(isCircularBarplotChart));
        } else if (typeof timeBucketData == 'undefined' && (horizontalTabIndex == 1 || horizontalTabIndex == 2)) {
            let startDate, endDate = startDate = moment(lastTS, 'YYYY/MM/DD').format('YYYY/MM/DD');
            if (horizontalTabIndex == 1) {
                //startDate = moment(startDate).subtract(1500, "minutes");
                startDate = endDate;
            }
            if (horizontalTabIndex == 2) {
                startDate = moment(startDate).subtract(7, "days");
            }
            startDate = moment(startDate).format('YYYY/MM/DD');
            endDate = moment(endDate).format('YYYY/MM/DD');
            this.setState({
                selectedStartDate: startDate,
                selectedEndDate: endDate
            }, () => {
                this.handleExecuteQueryDataGroup();
            });
            /*let message = "Please select time interval between " + startDate + " - " + endDate + " to see data for this time bucket.";
            this.setState({
                noAvailableData: true,
                noDataMessage: message
            });*/
        } else {
            this.setState({
                noAvailableData: true,
                noDataMessage: "No available data for this aggregation"
            });
        }
    }

    onKeyDown = name => event => {
        if (event.keyCode === 46) {
            // Delete button pressed
            this.handleDimChange(name, null);
        }
    };

    constructDrillDownRequest = (tsStart, tsEnd) => {
        let { dataGroupCode, queryParams, groupData } = this.state;
        let flattenedDimensions = [].concat(...groupData.aggregationDimensions.map(dim => [...dim.dimensions])),
            queryFields = flattenedDimensions.map(dim => dim);
        this.getDrillDownAthenaData({
            "dataGroup": dataGroupCode,
            "tsStart": tsStart,
            "tsEnd": tsEnd,
            "queryParams": queryParams,
            "queryFields": queryFields,
            "limit": 20,
            "offset": 0
        });
    };

    getDrillDownAthenaData = (athenaQuery) => {
        let accessToken = localStorage.getItem("access_token");
        this.setState({ errorString: '', isUserInputsValid: false, forbidAllActions: true, isGridUpdating: true });
        axiosInstance.post(`${EndpointsGetter.getDrillDownData()}`, athenaQuery, {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                if (isEmpty(response.data.drillDownResult)) {
                    this.setState({
                        forbidAllActions: false,
                        isUserInputsValid: false,
                        errorString: "Your raw data is not currently available. It will be available within 10 minutes!",
                        isGridUpdating: false
                    })
                } else {
                    this.setState({
                        drillDownResult: response.data.drillDownResult.map(el => JSON.parse(el)),
                        forbidAllActions: false,
                        athenaQuery: { ...athenaQuery, totalElements: response.data.totalRecordNumber },
                        isGridUpdating: false
                    });
                }
            })
            .catch(error => {
                this.getError(error);
            })
    }

    clearDrillDownData = () => {
        this.setState({ drillDownResult: [], athenaQuery: {} });
    }

    updateAthenaQuery = (value) => {
        this.setState(prevState => ({ athenaQuery: { ...prevState.athenaQuery, ...value } }), () => {
            this.getDrillDownAthenaData(this.state.athenaQuery);
        });
    }

    setDoughnutLabels = (isCircularBarplotChart) => {
        if (isCircularBarplotChart) {
            const doughnutLabels = this.getDoughnutLabels();
            this.setState({
                doughnutLabels
            });
            if (doughnutLabels.length > 0) {
                // select first period as default
                const defaultDoughnutLabel = Array.of(0);
                this.updateDoughnutSelectedIndexes(defaultDoughnutLabel);
            }
        }
    }

    /**
     * Retrieve labels shown on Doughnut.
     * Skip labels if too many of them - for reading purposes.
     */
    getDoughnutLabels = () => {
        let doughnutLabels = this.state.chartData.map(e => e.currentPeriod);
        if (doughnutLabels.length < DOUGHNUT_MAX_LABELS_SHOWN) {
            return doughnutLabels;
        }
        const showIndex = Math.floor(doughnutLabels.length / DOUGHNUT_MAX_LABELS_SHOWN) + 1;
        const lastEmptyLabels = Math.floor(doughnutLabels.length / DOUGHNUT_MAX_LABELS_SHOWN);
        return doughnutLabels.map((label, index) => {
            if (index % showIndex === 0 && index < doughnutLabels.length - lastEmptyLabels) {
                return label;
            }
            return "";
        })
    }

    updateCircularBarplotData = (doughnutSelectedBarIndexes) => {
        if (doughnutSelectedBarIndexes.length === 0) {
            this.setState({
                circularBarplotData: null,
                circularBarplotMaxHeight: -1,
                doughnutCenterText: '',
                doughnutIterationRunning: false
            });
        } else if (doughnutSelectedBarIndexes.length === 1) {
            const chartDataElem = this.state.chartData[doughnutSelectedBarIndexes[0]];
            let maxBarValue = 0;
            const circularBarplotData = [];
            this.state.chartAttributes.forEach(barName => {
                const barValue = chartDataElem[barName];
                if (typeof barValue !== 'undefined') {
                    if (barValue > maxBarValue) {
                        maxBarValue = barValue;
                    }
                    circularBarplotData.push({
                            name: barName,
                            value: barValue
                    });
                }
            });
            this.setState({
                circularBarplotData,
                circularBarplotMaxHeight: maxBarValue,
                doughnutCenterText: chartDataElem.currentPeriod
            });
        } else {
            let maxBarValue = 0;
            let circularBarplotData = [];
            this.state.chartAttributes.forEach(barName => {
                let sum = 0;
                let presentValue = false;
                doughnutSelectedBarIndexes.forEach(barIndex => {
                    const chartDataElem = this.state.chartData[barIndex];
                    const barValue = chartDataElem[barName];
                    if (typeof barValue !== 'undefined') {
                        presentValue = true;
                        sum += barValue;
                    }
                });
                if (presentValue) {
                    if (sum > maxBarValue) {
                        maxBarValue = sum;
                    }
                    circularBarplotData.push({
                        name: barName,
                        value: sum
                    });
                }
            });
            this.setState({
                circularBarplotData,
                circularBarplotMaxHeight: maxBarValue,
                doughnutCenterText: ''
            });
        }
    }

    renderCircularBarplotSection = () => {
        const { classes } = this.props;
        return (
            <div>
                <div className="row">
                    <div className="col-md-5">
                        <div className="row align-items-center justify-content-center">
                            <div className="col circular-barplot-tab-select-container">
                                {this.renderHorizontal()}
                            </div>
                            {this.state.doughnutLabels.length > 0 ?
                                <div style={{ width: '100%', marginTop: 207 }}>
                                    <DoughnutTimeSelector
                                        labels={this.state.doughnutLabels}
                                        selectedLabelIndexes={this.state.doughnutSelectedLabelsIndexes}
                                        updateDoughnutSelectedIndexes={this.updateDoughnutSelectedIndexes}
                                        iterationRunning={this.state.doughnutIterationRunning}
                                        iterationStop={() => this.stopDoughnutIteration}
                                        centerText={this.state.doughnutCenterText}
                                    />
                                    <div className="text-center">
                                        {this.state.doughnutIterationRunning ?
                                            <Button
                                                variant="contained"
                                                size="small"
                                                className={classes.button}
                                                style={{backgroundColor: '#fefefc'}}
                                                onClick={() => {this.setState({doughnutIterationRunning: false})}}
                                            >
                                                <PauseIcon
                                                    className={classNames(classes.leftIcon, classes.iconSmall)}
                                                    style={{backgroundColor: '#fefefc'}}
                                                />
                                                Pause
                                            </Button>
                                            : <Button
                                                variant="contained"
                                                size="small"
                                                className={classes.button}
                                                onClick={() => {this.setState({doughnutIterationRunning: true})}}
                                            >
                                                <PlayArrowIcon className={classNames(classes.leftIcon, classes.iconSmall)} />
                                                Play
                                            </Button>
                                        }
                                    </div>
                                </div> : null
                            }
                        </div>
                    </div>
                    <div className="col-md-7">
                        <div className="row">
                            <div className="col-md-12 circular-barplot-tab-select-container">
                                <div className="float-right">
                                    {this.renderVertical()}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-11">
                                        {this.state.circularBarplotData !== null ?
                                            this.state.circularBarplotData.length > 0 ?
                                                <CircularBarplot
                                                    data={this.state.circularBarplotData}
                                                    maxBarHeight={this.state.circularBarplotMaxHeight}
                                                />
                                                : <div className="alert alert-warning alert-dismissible" style={{ marginTop: 20 }} role="alert">
                                                    No data for selected time period.
                                                </div>
                                            : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    updateDoughnutSelectedIndexes = (selectedBarIndexes) => {
        this.updateCircularBarplotData(selectedBarIndexes);
        this.setState({
            doughnutSelectedLabelsIndexes: selectedBarIndexes
        });
    }

    stopDoughnutIteration = () => {
        this.setState({
            doughnutIterationRunning: false
        });
    }

    renderHorizontal = () => {
        return (
            <Paper className="row justify-content-center circular-barplot-tab-select-card">
                <div className="col text-center">
                    <InputLabel htmlFor="attribute-select">Aggregation Time Bucket</InputLabel><br />
                    <Select
                        value={this.state.selectedHorizontalTabIndex}
                        onChange={this.handleHorizontalChange}
                    >
                        {this.state.circularHorizontalIndexes.map(id => {
                                return (
                                    <MenuItem key={id} value={id}>
                                        {'by ' + this.state.timeBuckets[id - 1].name}
                                    </MenuItem>
                                );
                            })
                        }
                    </Select>
                </div>
            </Paper>
        );
    }

    handleHorizontalChange = (event) => {
        const horizontalTabIndex = event.target.value;
        this.setState({
            selectedHorizontalTabIndex: horizontalTabIndex,
            doughnutIterationRunning: false
        });
        this.setChartData(horizontalTabIndex, this.state.selectedVerticalTabIndex, true);
    }

    getAccumulateUniqueAttributeIds = (output) => {
        let ids = [];
        for (let i = 0; i < output.length; i++) {
            let aggregationType = this.state.aggregationTypes.find(obj => {
                return obj.id === output[i].OperationTypeId
            });
            if (typeof aggregationType !== 'undefined' && aggregationType.name === ATTRIBUTE_ACCUMULATE_UNIQUE) {
                ids.push(i);
            }
        }
        return ids;
    }

    getCircularChartHorizontalIndexes = () => {
        const sortedGroupTimeBuckets = this.sortAggregationTimeBuckets();
        let horizontalIndexes = [];
        for (let i = 0; i < sortedGroupTimeBuckets.length; i++) {
            const groupTbId = sortedGroupTimeBuckets[i].id;
            //hide real time data for now from the query screen
            if (groupTbId >= CIRCULAR_BARPLOT_MIN_AGGREGATION_INDEX && groupTbId !== 9) {
                horizontalIndexes.push(groupTbId);
            }
        }
        return horizontalIndexes;
    }

    renderVertical = () => {
        // Accumulate Unique Aggregate
        return (
            <Paper className="row justify-content-center circular-barplot-tab-select-card">
                <div className="text-center">
                    <InputLabel htmlFor="attribute-select">Accumulate Unique Aggregate</InputLabel><br />
                    <Select
                        value={this.state.selectedVerticalTabIndex}
                        onChange={this.handleVerticalChange}
                    >
                        {this.state.circularVerticalIndexes.map(i => {
                                return (
                                    <MenuItem key={i+1} value={(i+1)}>
                                        {this.state.output[i].Attribute}
                                    </MenuItem>
                                );
                            })
                        }
                    </Select>
                </div>
            </Paper>
        );
    }

    handleVerticalChange = (event) => {
        const index = event.target.value;
        this.setState({
            selectedVerticalTabIndex: index,
            doughnutIterationRunning: false
        });
        this.setChartData(this.state.selectedHorizontalTabIndex, index, true);
    }

    updateSelectedTabIndexes = () => {
        const attrIds = this.getAccumulateUniqueAttributeIds(this.state.output);
        const selectedVerticalTabIndex = parseInt(attrIds[0] + 1, 10);

        const timebucketIds = this.getCircularChartHorizontalIndexes();
        let selectedHorizontalTabIndex = timebucketIds[0] < this.state.selectedHorizontalTabIndex ?
            this.state.selectedHorizontalTabIndex : timebucketIds[0];
        selectedHorizontalTabIndex = parseInt(selectedHorizontalTabIndex, 10);

        this.setState({
            circularVerticalIndexes: attrIds,
            circularHorizontalIndexes: timebucketIds,
            selectedVerticalTabIndex,
            selectedHorizontalTabIndex
        });
        return {
            selectedVerticalTabIndex: selectedVerticalTabIndex,
            selectedHorizontalTabIndex: selectedHorizontalTabIndex
        };
    }

    handleChartTabSelection = (tabId) => {
        if (tabId === TAB_KEY_LINE_CHART) {
            this.setChartData(this.state.selectedHorizontalTabIndex, this.state.selectedVerticalTabIndex, false);
            this.setState({
                tabListSelectedTab: TAB_KEY_LINE_CHART
            });
        } else if (tabId === TAB_KEY_CIRCULAR_CHART) {
            if (this.state.circularBarplotVisualizationAvailable) {
                const selection = this.updateSelectedTabIndexes();
                this.setChartData(selection.selectedHorizontalTabIndex, selection.selectedVerticalTabIndex, true);
                this.setState({
                    tabListSelectedTab: TAB_KEY_CIRCULAR_CHART
                });
            }
        }
    }

    render() {
        const { classes, theme } = this.props;
        const {
            dataGroupName, dataGroupCode, url, query, queries, dimensions, startDate, endDate, selectedStartDate,
            selectedEndDate, output, dim1, dim2, dim3, dim4, dim5, dimsSuggestions, fiscalYearStartDate, setFiscalYear, lookupInputDelay,
            drillDownResult, forbidAllActions, athenaQuery, isGridUpdating, queryParamsForPdfExport, chartAttributes
        } = this.state;

        const selectStyles = {
            input: base => ({
                ...base,
                color: theme.palette.text.primary,
                '& input': {
                    font: 'inherit',
                },
            })
        };

        return (
            <Fragment>
                {forbidAllActions ? (
                    <div className={classNames(classes.circularProgress)}>
                        <CircularProgress color="secondary" />
                        <span className={classNames(classes.progressText)}> Fetching data. This might take some time... </span>
                    </div>
                ) : null}
                <div style={{ pointerEvents: forbidAllActions ? 'none' : 'auto', 'filter': forbidAllActions ? 'blur(3px)' : 'blur(0px)' }}>
                    <FusePageSimple
                        classes={{
                            root: classes.layoutRoot
                        }}
                        header={
                            <div className='header-container'>
                                <div>
                                    <h4 className='header-title'><b>Data Group:</b> {dataGroupName}({dataGroupCode})</h4>
                                    <label className='header-title'>{url}</label>
                                </div>
                            </div>
                        }
                        content={
                            <div className='container-fluid'>
                                <DrillDownDataContainer
                                    drillDownData={drillDownResult}
                                    clearDrillDownData={this.clearDrillDownData}
                                    athenaQuery={athenaQuery}
                                    updateAthenaQuery={this.updateAthenaQuery}
                                    isGridUpdating={isGridUpdating}
                                />
                                {!this.state.isUserInputsValid ?
                                    <div className="screen-layout">
                                        <label className="text-area-label col-lg-6"
                                            style={{ color: 'red' }}>{this.state.errorString}</label>
                                    </div>
                                    : null
                                }
                                {
                                    output != null ?
                                        <div className="charts-container">
                                            <Tabs
                                                defaultTab={TAB_KEY_LINE_CHART}
                                                onChange={(tabId) => this.handleChartTabSelection(tabId)}
                                            >
                                                <TabList className="tablist-container">
                                                    <Tab tabFor={TAB_KEY_LINE_CHART}>Line Chart</Tab>
                                                    <Tab tabFor={TAB_KEY_CIRCULAR_CHART}>Radar Bars</Tab>
                                                </TabList>
                                                {this.state.tabListSelectedTab === TAB_KEY_LINE_CHART ?
                                                    <TabPanel tabId="chart-tab">
                                                        <div className="container" style={{ width: '100%' }}>
                                                            <div className="row">
                                                                <table style={{
                                                                    tableLayout: 'auto',
                                                                    minWidth: '85%',
                                                                    maxWidth: '100%',
                                                                    margin: 20
                                                                }}>
                                                                    <tbody>
                                                                    <tr>
                                                                        <td></td>
                                                                        <td>
                                                                            <Tabs
                                                                                defaultTab={this.state.selectedHorizontalTabIndex.toString()}
                                                                                onChange={(tabId) => {
                                                                                    this.setState({
                                                                                        selectedHorizontalTabIndex: tabId
                                                                                    });
                                                                                    this.setChartData(tabId, this.state.selectedVerticalTabIndex, false);
                                                                                }}
                                                                            >
                                                                                <TabList>
                                                                                    {this.createHorizontalTabs()}
                                                                                </TabList>
                                                                            </Tabs>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{ verticalAlign: 'top' }}>
                                                                            <Tabs
                                                                                vertical
                                                                                defaultTab={this.state.selectedVerticalTabIndex.toString()}
                                                                                onChange={(tabId) => {
                                                                                    this.setState({
                                                                                        selectedVerticalTabIndex: tabId
                                                                                    });
                                                                                    this.setChartData(this.state.selectedHorizontalTabIndex, tabId, false);
                                                                                }}>
                                                                                <TabList style={{ paddingRight: 0, marginRight: 0 }}>
                                                                                    {this.createVerticalTabs()}
                                                                                </TabList>
                                                                            </Tabs>
                                                                        </td>
                                                                        <td style={{ background: 'white', textAlign: 'center' }}>
                                                                            {this.state.noAvailableData ?
                                                                                <label className="text-area-label"
                                                                                       style={{ color: 'red' }}>
                                                                                    {this.state.noDataMessage}
                                                                                </label> :
                                                                                <QueryChart
                                                                                    chartData={this.state.chartData}
                                                                                    chartCursorFormat={this.state.chartCursorFormat}
                                                                                    minPeriod={this.state.minPeriod}
                                                                                    showBullets={this.state.alwaysShowBullets}
                                                                                    chosenCategory={this.state.chosenCategory}
                                                                                    constructDrillDownRequest={this.constructDrillDownRequest}
                                                                                    dataGroupName={dataGroupName}
                                                                                    startDate={startDate}
                                                                                    endDate={endDate}
                                                                                    queryParams={queryParamsForPdfExport}
                                                                                    chartAttributes={chartAttributes}
                                                                                />}
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </TabPanel>
                                                    : null
                                                }
                                                {this.state.tabListSelectedTab === TAB_KEY_CIRCULAR_CHART ?
                                                    <TabPanel tabId="circular-chart-tab">
                                                        {this.state.circularBarplotVisualizationAvailable ?
                                                            this.renderCircularBarplotSection() :
                                                            <div className="alert alert-warning alert-dismissible" style={{ marginTop: 20 }} role="alert">
                                                                This visualization is only available for data group with Accumulate Unique aggregation
                                                            </div>
                                                        }
                                                    </TabPanel>: null
                                                }
                                            </Tabs>
                                        </div>
                                        : null
                                }
                                <div className="row screen-layout">
                                    <div className="col-lg-8">
                                        <DataGroupInfoTable groupData={this.state.groupData} />
                                        <br />
                                        <div className="row screen-layout">
                                            <div className="col-lg-3 col-sm-6">
                                                <TimeBucketsTable
                                                    timeBuckets={this.state.groupData ? this.state.groupData.aggregationTimeBuckets : null}
                                                />
                                            </div>
                                            <div className="col-lg-3 col-sm-6">
                                                <AggregatesTable
                                                    aggregationTypes={this.state.aggregationTypes}
                                                    groupAggTypes={this.state.groupData ? this.state.groupData.attributesAndAggregationTypes : null}
                                                />
                                            </div>
                                            <div className="col-lg-6 col-sm-12">
                                                <DimensionsTable
                                                    aggregationDimensions={this.state.groupData ? this.state.groupData.aggregationDimensions : null}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 container">
                                        <InputLabel htmlFor="query">Query</InputLabel>
                                        <Select
                                            value={query}
                                            onChange={this.handleQueryChange('query')}
                                            inputProps={{
                                                name: 'query',
                                                id: 'query'
                                            }}
                                        >
                                            {queries.map((q, idx) => {
                                                return (
                                                    <MenuItem key={idx} value={q.value}>{q.value}</MenuItem>
                                                );
                                            })}
                                        </Select>
                                        {query != '' ?
                                            <div className="inner-container">
                                                {dimensions[0].d1 != '' ?
                                                    <div className={classes.dimAttributes}>
                                                        <InputLabel htmlFor="dim1">{dimensions[0].d1}*</InputLabel>
                                                        {<ReactSelect
                                                            isLoading={this.state.dimsLoadingStatus['dim1']}
                                                            className={classNames(classes.typeaheader)}
                                                            classNamePrefix="select"
                                                            options={dimsSuggestions['dim1']}
                                                            value={dim1}
                                                            onFocus={(e) => this.handleFocus(e, dimensions[0].d1, 'dim1')}
                                                            onChange={this.onDimChange('dim1')}
                                                            onInputChange={debounce(this.handleInputChange(dimensions[0].d1, 'dim1'), lookupInputDelay)}
                                                            name="dim1"
                                                            classes={classes}
                                                            components={reactSelectComponents}
                                                            styles={selectStyles}
                                                            onKeyDown={this.onKeyDown('dim1')}
                                                        />}
                                                    </div>
                                                    : null
                                                }
                                                {dimensions[0].d2 != '' ?
                                                    <div className={classes.dimAttributes}>
                                                        <InputLabel htmlFor="dim2">{dimensions[0].d2}*</InputLabel>
                                                        {<ReactSelect
                                                            isLoading={this.state.dimsLoadingStatus['dim2']}
                                                            className={classNames(classes.typeaheader)}
                                                            classNamePrefix="select"
                                                            options={dimsSuggestions['dim2']}
                                                            value={dim2}
                                                            onFocus={(e) => this.handleFocus(e, dimensions[0].d2, 'dim2')}
                                                            onChange={this.onDimChange('dim2')}
                                                            onInputChange={debounce(this.handleInputChange(dimensions[0].d2, 'dim2'), lookupInputDelay)}
                                                            name="dim2"
                                                            classes={classes}
                                                            components={reactSelectComponents}
                                                            styles={selectStyles}
                                                            onKeyDown={this.onKeyDown('dim2')}
                                                        />}
                                                    </div>
                                                    : null
                                                }
                                                {dimensions[0].d3 != '' ?
                                                    <div className={classes.dimAttributes}>
                                                        <InputLabel htmlFor="dim3">{dimensions[0].d3}*</InputLabel>
                                                        {<ReactSelect
                                                            isLoading={this.state.dimsLoadingStatus['dim3']}
                                                            className={classNames(classes.typeaheader, "basic-multi-select")}
                                                            classNamePrefix="select"
                                                            options={dimsSuggestions['dim3']}
                                                            value={dim3}
                                                            onFocus={(e) => this.handleFocus(e, dimensions[0].d3, 'dim3')}
                                                            onChange={this.onDimChange('dim3')}
                                                            onInputChange={debounce(this.handleInputChange(dimensions[0].d3, 'dim3'), lookupInputDelay)}
                                                            name="dim3"
                                                            classes={classes}
                                                            components={reactSelectComponents}
                                                            styles={selectStyles}
                                                            onKeyDown={this.onKeyDown('dim3')}
                                                        />}
                                                    </div>
                                                    : null
                                                }
                                                {dimensions[0].d4 != '' ?
                                                    <div className={classes.dimAttributes}>
                                                        <InputLabel htmlFor="dim4">{dimensions[0].d4}*</InputLabel>
                                                        {<ReactSelect
                                                            isLoading={this.state.dimsLoadingStatus['dim4']}
                                                            className={classNames(classes.typeaheader, "basic-multi-select")}
                                                            classNamePrefix="select"
                                                            options={dimsSuggestions['dim4']}
                                                            value={dim4}
                                                            onFocus={(e) => this.handleFocus(e, dimensions[0].d4, 'dim4')}
                                                            onChange={this.onDimChange('dim4')}
                                                            onInputChange={debounce(this.handleInputChange(dimensions[0].d4, 'dim4'), lookupInputDelay)}
                                                            name="dim4"
                                                            classes={classes}
                                                            components={reactSelectComponents}
                                                            styles={selectStyles}
                                                            onKeyDown={this.onKeyDown('dim4')}
                                                        />}
                                                    </div>
                                                    : null
                                                }
                                                {dimensions[0].d5 != '' ?
                                                    <div className={classes.dimAttributes}>
                                                        <InputLabel htmlFor="dim5">{dimensions[0].d5}*</InputLabel>
                                                        {<ReactSelect
                                                            isLoading={this.state.dimsLoadingStatus['dim5']}
                                                            className={classNames(classes.typeaheader, "basic-multi-select")}
                                                            classNamePrefix="select"
                                                            options={dimsSuggestions['dim5']}
                                                            value={dim5}
                                                            onFocus={(e) => this.handleFocus(e, dimensions[0].d5, 'dim5')}
                                                            onChange={this.onDimChange('dim5')}
                                                            onInputChange={debounce(this.handleInputChange(dimensions[0].d5, 'dim5'), lookupInputDelay)}
                                                            name="dim5"
                                                            classes={classes}
                                                            components={reactSelectComponents}
                                                            styles={selectStyles}
                                                            onKeyDown={this.onKeyDown('dim5')}
                                                        />}
                                                    </div>
                                                    : null
                                                }
                                                <div style={{
                                                    display: 'flex',
                                                    'flexDirection': 'row', 'flexWrap': 'wrap'
                                                }}>
                                                    <div>
                                                        <DatePicker
                                                            keyboard
                                                            id="startDatePicker"
                                                            label="Start Date"
                                                            format="YYYY/MM/DD"
                                                            minDate={startDate}
                                                            maxDate={selectedEndDate}
                                                            // handle clearing outside => pass plain array if you are not controlling value outside
                                                            mask={value => (value ? [/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/] : [])}
                                                            value={selectedStartDate}
                                                            onChange={this.handleDateChange('selectedStartDate')}
                                                            onInputChange={(e) => this.validateDates('selectedStartDateValid', startDate, selectedEndDate, e.target.value)}
                                                            animateYearScrolling={false}
                                                            style={{ marginTop: 20, marginBottom: 20, marginRight: 10 }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <DatePicker
                                                            keyboard
                                                            id="endDatePicker"
                                                            label="End Date"
                                                            format="YYYY/MM/DD"
                                                            minDate={selectedStartDate}
                                                            maxDate={endDate}
                                                            // handle clearing outside => pass plain array if you are not controlling value outside
                                                            mask={value => (value ? [/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/] : [])}
                                                            value={selectedEndDate}
                                                            onChange={this.handleDateChange('selectedEndDate')}
                                                            onInputChange={(e) => this.validateDates('selectedEndDateValid', selectedStartDate, endDate, e.target.value)}
                                                            animateYearScrolling={false}
                                                            style={{ marginTop: 20, marginBottom: 20, marginRight: 20 }}
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <FormLabel className={classes.inputLabels} style={{ width: '100%' }}> Week Date Standard </FormLabel>
                                                    <Select
                                                        value={this.state.weekStandard}
                                                        onChange={this.handleChange('weekStandard')}
                                                        inputProps={{
                                                            name: 'weekStandard',
                                                            id: 'weekStandard',
                                                        }}
                                                    >
                                                        {this.state.weekStandards.map((e, idx) => {
                                                            return <MenuItem key={idx} value={e.value}>{e.label}</MenuItem>
                                                        })}
                                                    </Select>
                                                </div>
                                                <div>
                                                    <div style={{ width: '100%' }}>
                                                        <FormLabel className={classes.inputLabels}>Set Fiscal Year</FormLabel>
                                                        <Checkbox
                                                            onChange={(e) => {
                                                                if (setFiscalYear) {
                                                                    this.setState({
                                                                        fiscalYearStartDay: 1,
                                                                        fiscalYearStartMonth: 1,
                                                                        fiscalYearStartDate: new Date(new Date().getFullYear(), 0, 1),
                                                                        setFiscalYear: !setFiscalYear,
                                                                        fiscalYearStartDateValid: true
                                                                    });
                                                                } else {
                                                                    this.setState({ setFiscalYear: !setFiscalYear })
                                                                }
                                                            }}
                                                            checked={setFiscalYear} />
                                                    </div>
                                                    {setFiscalYear ?
                                                        <DatePicker
                                                            keyboard
                                                            clearable
                                                            id="endDatePicker"
                                                            format="YYYY/MM/DD"
                                                            label="Fiscal Year Start"
                                                            /* minDate={selectedStartDate}
                                                             maxDate={endDate}*/
                                                            mask={value => (value ? [/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/] : [])}
                                                            value={fiscalYearStartDate}
                                                            onChange={this.handleFiscalYearDateChange('fiscalYearStartDate')}
                                                            onInputChange={(e) => this.validateDates('fiscalYearStartDateValid', null, null, e.target.value)}
                                                            animateYearScrolling={false}
                                                            disabled={!setFiscalYear}
                                                        /> : null
                                                    }
                                                </div>
                                                <Button variant="outlined" color="secondary"
                                                    className={classes.execButton}
                                                    onClick={(e) => this.handleExecuteQueryDataGroup()}
                                                    disabled={!this.state.selectedStartDateValid || !this.state.selectedEndDateValid ||
                                                        !this.state.fiscalYearStartDateValid || this.state.executeDisabled}>
                                                    Execute
                                                </Button>
                                            </div>
                                            : null}
                                    </div>
                                </div>
                            </div>
                        }
                    />
                </div>
            </Fragment>
        );
    }
}

QueryScreen.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(withRouter(QueryScreen));



// WEBPACK FOOTER //
// ./src/main/content/query/QueryScreen.js